export default __webpack_public_path__ + "static/media/txt_entrance_09.c452d6a5.svg";